/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaSelect from 'DesignSystem/TysiaSelect/index'
import TysiaSelectContent from 'DesignSystem/TysiaSelect/TysiaSelectContent/index'
import TysiaSelectField from 'DesignSystem/TysiaSelect/TysiaSelectField/react'
import TysiaSelectLabel from 'DesignSystem/TysiaSelect/TysiaSelectLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/MessageTools/External/SendFrom/Content",
  onChange,
  isSubmitting
  
}) {
let messageComposeAllowedToSendFromValueData = fromData.useDataValue({ viewPath,
context: 'message_compose',
path: 'allowed_to_send_from',
})
let messageComposeSendFromIdValueData = fromData.useDataValue({ viewPath,
context: 'message_compose',
path: 'send_from_id',
})
let messageComposeSendFromIdChangeData = fromData.useDataChange({ viewPath,
context: 'message_compose',
path: 'send_from_id',
})
let messageComposeSendFromIdIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'message_compose',
})
  return (<React.Fragment
>
<TysiaSelect
  viewPath={`${viewPath}/TysiaSelect`}
 marginTop={0}
 marginLeft={8}
 maxWidth={250}
 size="small"
 data="message_compose.allowed_to_send_from"
 from={messageComposeAllowedToSendFromValueData}
 data="message_compose.send_from_id"
 value={messageComposeSendFromIdValueData}
 onChange={messageComposeSendFromIdChangeData}
 disabled={messageComposeSendFromIdIsSubmittingData}
>
{childProps => (
<React.Fragment>
<TysiaSelectLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectLabel`}
 text="Send from:"
/>
<TysiaSelectContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectContent`}
 allowEmptyChoice={false}
>
{childProps => (
<TysiaSelectField
{...childProps}
  viewPath={`${viewPath}/TysiaSelectField`}
/>
)}
</TysiaSelectContent>
</React.Fragment>
)}
</TysiaSelect>
{children}
</React.Fragment>)
}